import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authenticate } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import messages from '../../utils/messages';

const Auth = ({ setAdditionalParamMap }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleAuthentication = async () => {
      try {
        // Get query parameters from URL
        const queryParams = new URLSearchParams(location.search);
        const sk = queryParams.get('sk');
        const apiSig = queryParams.get('api_sig');

        // sk="123"
        // apiSig="abc"

        const companyId = queryParams.get('companyId');
        const companyName = queryParams.get('companyName');
        const userName = queryParams.get('userName');
        const patientId = queryParams.get('patientId');
        const filenames = queryParams.get('filenames');



        if (!sk || !apiSig) {
          setError(messages.errors.MISSING_AUTH_PARAMS);
          setLoading(false);
          return;
        }

        // Call authentication service
        const enableMockServices = process.env.REACT_APP_ENABLE_MOCK_SERVICES === 'true';
        let result = "";
        if (enableMockServices) {
          result  = {"success":true,"token":"123456"};
        }else{
          result = await authenticate(sk, apiSig, companyId, userName, companyName );
        }
        if (result.success && result.token) {
          // Saving Received Data
          setAdditionalParamMap({
            "companyId": companyId,
            "companyName": companyName,
            "userName": userName,
          });

          // Authentication successful
          login(result.token);
          
          // Redirect to the main application
          navigate('/upload', { state: { patientId, filenames } });
        } else {
          // Authentication failed
          setError(result.message || messages.errors.AUTHENTICATION_FAILED);
          setLoading(false);
          
          // After showing the error message for 3 seconds, redirect to unauthorized page
          setTimeout(() => {
            navigate('/unauthorized', { state: { authFailed: true } });
          }, 0);
        }
      } catch (err) {
        setError(messages.errors.UNEXPECTED_ERROR);
        setLoading(false);
        //console.error('Authentication error:', err);
      }
    };

    handleAuthentication();
  }, [location, login, navigate]);

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Authentication in Progress</h2>
          <p>Please wait while we authenticate your credentials...</p>
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-card error">
          <h2>Authentication Failed</h2>
          <p>{error}</p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default Auth;
